import React from 'react';
import Img from 'gatsby-image';

import { useStaticQuery, graphql } from 'gatsby';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';

import withLocation from 'src/components/withLocation';
import Selectors from 'src/state/root-selectors';

import * as confirmationStyles from 'src/styles/confirmation-page.module.scss';
import CheckoutFooter from '../checkout/CheckoutFooter';

const ConfirmationPage = ({ children, user, title, subtitle }) => {
    const checkmarkImgData = useStaticQuery(graphql`
        query {
            file(relativePath: { eq: "checkmark-circle-2.png" }) {
                childImageSharp {
                    fluid(maxWidth: 130) {
                        ...GatsbyImageSharpFluid
                    }
                }
            }
        }
    `);

    return (
        <>
            <div className={confirmationStyles.contentWrapper}>
                <Grid columns={2} centered stackable>
                    <Grid.Row>
                        <Grid.Column>
                            <div className={confirmationStyles.primaryContent}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column width={3}>
                                            <Img
                                                fluid={checkmarkImgData.file.childImageSharp.fluid}
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={13}>
                                            <h1 className="upper">{title || 'Confirmed'}</h1>
                                            {subtitle && <h3 className="upper">{subtitle}</h3>}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column textAlign="center">
                            <div className={confirmationStyles.secondaryContent}>{children}</div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>

            <CheckoutFooter />
        </>
    );
};

const mapStateToProps = (state) => ({
    user: Selectors.auth.user(state),
});

export default connect(mapStateToProps)(withLocation(ConfirmationPage));
